
declare const __API_BASE_URL__: string;
declare const __DEPLOY_MODE__: string;
declare const __ENTRA_TENANT_ID__: string;
declare const __ENTRA_CLIENT_ID__: string;
declare const __ENTRA_TENANT_SECRET__: string;

type DeployMode = 'production' | 'homologation' | 'development' | 'local';

export const getEnvMode = (): DeployMode => {
  return typeof __DEPLOY_MODE__ !== 'undefined'
    ? (__DEPLOY_MODE__ as DeployMode)
    : 'local';
};

export const getEnvApiUrl = (): string => {
  return typeof __API_BASE_URL__ !== 'undefined'
    ? __API_BASE_URL__
    : 'http://localhost:8070/cadp-bff-estipulante/';
};

export const getEntraTenantId = (): string => {
  return typeof __ENTRA_TENANT_ID__ !== 'undefined' ? __ENTRA_TENANT_ID__ : '';
};

export const getEntraClientId = (): string => {
  return typeof __ENTRA_CLIENT_ID__ !== 'undefined' ? __ENTRA_CLIENT_ID__ : '';
};

export const getEntraTenantSecret = (): string => {
  return typeof __ENTRA_TENANT_SECRET__ !== 'undefined' ? __ENTRA_TENANT_SECRET__ : '';
};

export const logEntraDeployDebug = (): void => {
  console.log('mode:', getEnvMode());
  console.log('__ENTRA_TENANT_ID__:', getEntraTenantId());
  console.log('__ENTRA_CLIENT_ID__:', getEntraClientId());
  console.log('entraTenantSecret:', getEntraTenantSecret() || '(undefined)');
};